export type StyleType = {
  [k: string]: string;
};

const useCssVariable = (style: StyleType) => {
  return style;
};

export default useCssVariable;
